<template>
    <v-container fluid>
        <v-card class="elevation-3" :loading="loading">
            <div class="card-title">{{ $t('Surveys') }}</div>
            <v-card-text>
                <v-card-title>
                    <v-row>
                        <v-col cols="6" md="6">
                            <v-text-field dense outlined clearable v-model="search" append-icon="mdi-magnify" :label="$t('Search')" single-line hide-details />
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete searchable
                                            multiple
                                            dense
                                            clearable
                                            outlined
                                            v-model.lazy="selectedMunicipalityItems"
                                            :items="itemsMunicipality"
                                            item-value="id"
                                            item-text="municipalityName"
                                            :menu-props="{ maxHeight: '150' }"
                                            style="z-index: 999999"
                                            :label="$t('sharedWithMunicipality')">
                                <template v-slot:prepend-item>
                                    <v-list-item @click="selectAllItems">
                                        <v-list-item-content>{{ $t('SelectAll') }}</v-list-item-content>
                                    </v-list-item>
                                </template>
                                <template v-slot:item="{ item }">
                                    <v-list-item-content>
                                        <h4>{{ item.municipalityName }}</h4>
                                    </v-list-item-content>
                                </template>
                                <template v-slot:selection="{ item }">
                                    <v-chip small :key="item.id" close @click:close="removeItem(item.id)">
                                        {{ item.municipalityName }}
                                    </v-chip>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>

                </v-card-title>

                <v-data-table :headers="headers" dense :items="filteredList" :search="search" class="mt-6" @dblclick:row="(event, { item }) => editSurvey(item.id)">
                    <template v-slot:[`item.nameAr`]="{ item }">
                        {{ RemoveHtmlTags(item.nameAr) }}
                    </template>
                    <!--<template v-slot:[`item.nameEn`]="{ item }">
                        {{ RemoveHtmlTags(item.nameEn) }}
                    </template>-->
                    <template v-slot:[`item.expiryDate`]="{ item }">
                        {{ item.expiryDate | formatDateGregorian }}
                    </template>
                    <template v-slot:[`item.startDate`]="{ item }">
                        {{ item.startDate | formatDateGregorian }}
                    </template>
                    <template v-slot:[`item.description`]="{ item }">
                        {{ item.description }}
                    </template>

                    <template v-slot:[`item.actions`]="{ item }">
                        <table>
                            <tr>
                                <td v-if="item.statusId == approved" style="padding:10px">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <router-link :to="{ name: 'survey-analyticsShared', params: { id: item.id }}">
                                                <v-icon color="primary" role="link" v-bind="attrs" v-on="on">mdi-chart-areaspline</v-icon>
                                            </router-link>
                                        </template>
                                        <span>{{ $t('Analytics') }}</span>
                                    </v-tooltip>
                                </td>
                            </tr>
                        </table>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>
    </v-container></template>

<script lang="ts">
    import { mapGetters } from 'vuex'
    import SurveyService from '@/services/SurveyService.js'
    import StructuresService from '@/services/StructuresService.js'
    import UsersService from '@/services/UsersService.js'
    import { SurveyStatusEnum } from '@/helpers/constants/enumerations.js'
    import domtoimage from 'dom-to-image'
    import { useStripHtml } from '@/helpers/common.js'


    export default {

        data() {
            return {
                search: '',
                selectedSurveyId: 0,
                loading: false,
                enabled: false,
                isShared: null,
                isSharedQrForm: null,
                isPublished: null,
                active: null,
                showOnHomePage: null,
                surveys: [],
                mainSurveyList: [],
                userPermissionsList: [],

                headers: [
                    { text: this.$t('Id'), value: 'id' },
                    { text: this.$t('NameAr'), value: 'nameAr', width: '15%', },
                    //{ text: this.$t('NameEn'), value: 'nameEn', width: '15%', },
                    { text: this.$t('CreatedBy'), value: 'description' },
                    { text: this.$t('StartDate'), value: 'startDate' },
                    { text: this.$t('ExpiryDate'), value: 'expiryDate' },
                    { text: this.$t('Actions'), value: 'actions' },

                ],
                selectedItem: null,
                draft: SurveyStatusEnum.Draft,
                approved: SurveyStatusEnum.Approved,
                qrCodeDialog: false,
                surveyURL: '',
                selectedTitle: '',
                selectedMunicipalityItems: [],
                itemsMunicipality: [],
                isShowMunicipality: false

            }
        },

        created() {
            this.listSruveys()
            this.getMunicipality()
        },
        mounted() {
            this.hasUpdatePermission()
        },
        computed: {
            ...mapGetters('user', ['language']),
            getLanguage() {
                return this.language == null ? 'ar' : this.language

            },
            filteredList() {

                let surveyFilter = this.surveys
                    .map(task => {
                        const taskShareWithMunicipalities = task.shareWithMunicipalities ?task.shareWithMunicipalities
                            .split(',')
                            .map(item => item.trim())
                            .map(Number):[]

                        const hasSelectedMunicipalities = this.selectedMunicipalityItems.length === 0

                        const hasMatchingMunicipality = taskShareWithMunicipalities.some(id => {
                            return this.selectedMunicipalityItems.includes(Number(id))
                        })
                        const matchesMunicipality = hasSelectedMunicipalities || hasMatchingMunicipality

                        return {
                            ...task,
                            matchesMunicipality
                        }
                    })
                    .filter(task => {
                        return task.matchesMunicipality &&
                            (this.showOnHomePage == null ||
                                this.showOnHomePage === false ||
                                task.showOnHomePage === this.showOnHomePage) &&
                            (this.isShared == null ||
                                this.isShared === false ||
                                task.isShared === this.isShared) &&
                            (this.isPublished == null ||
                                this.isPublished === false ||
                                task.isPublished === this.isPublished) &&
                            (this.active == null ||
                                this.active === false ||
                                task.expired !== this.active)
                    })
                return surveyFilter
            }


        },
        methods: {
            getMunicipality() {
                StructuresService.listMunicipalitiesShared().then((res) => {
                    if (res.data.length > 0) {
                        this.isShowMunicipality = true
                        this.itemsMunicipality = res.data.map(item => ({
                            id: item.id,
                            municipalityName: item.name
                        }))
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },

            removeItem(id) {
                const index = this.selectedMunicipalityItems.indexOf(id)
                if (index !== -1) {
                    this.selectedMunicipalityItems.splice(index, 1)
                }
            },
            selectAllItems() {
                this.selectedMunicipalityItems = this.itemsMunicipality.map(item => item.id)
            },
            downloadQR() {
                // Reference to the qrcode-vue component
                const qrcodeEl = this.$refs.qrcode.$el

                // Convert the SVG element to a data URL
                domtoimage.toPng(qrcodeEl)
                    .then(dataUrl => {
                        // Create a link element
                        const link = document.createElement('a')
                        link.href = dataUrl
                        link.download = 'qrcode.png'

                        // Simulate click on the link to trigger download
                        link.click()
                    })
                    .catch(error => {
                    })
            },
            shareSurvey(value) {
                this.loading = true
                SurveyService.shareSurvey(this.selectedSurveyId, value).then((res) => {
                    this.listSruveys()
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            getTitle(question) {
                return this.language == 'ar' || this.language == null ? question.nameAr : question.nameEn
            },
            hasUpdatePermission() {
                UsersService.listCurrentUserPermissions().then((res) => {
                    if (res.data) {
                        this.userPermissionsList = res.data
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            handleAction(action, item) {
                switch (action.action) {
                    case 'edit':
                        this.editSurvey(item.id)
                        break
                    case 'delete':
                        this.removeSurvey(item.id)
                        break
                    case 'results':
                        this.resultsSurvey(item.id)
                        break
                    case 'view':
                        this.editSurvey(item.id)
                        break
                    case 'copy':
                        this.copy(item.id)
                        break
                    case 'copyHtml':
                        this.generateHtml(item.id)
                        break
                    case 'analytics':
                        this.surveyAnalytics(item.id)
                        break
                    case 'qrCode':
                        this.genrateQrCode(item.id)
                        break
                    case 'makeCopy':
                        this.makeCopy(item.id)
                        break
                    default:
                        break
                }
            },
            editSurvey(id) {
                this.$router.push({ name: 'add-survey', query: { id } })
            },
            resultsSurvey(id) {
                this.$router.push({ name: 'survey-results', query: { id } })
            },
            surveyAnalytics(id) {
                this.$router.push({ name: 'survey-analyticsShared', query: { id } })
            },

            listSruveys() {
                this.loading = true
                SurveyService.listSurveys(true).then((res) => {
                    this.surveys = res.data
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },

            copy(itemId) {
                navigator.clipboard.writeText(window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + `/form/${itemId}`)
                this.$root.$notification(this.$t('CopySucceeded'), 'success')
            },
            generateHtml(itemId) {
                var url = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + `/form/${itemId}`
                var html = `<iframe id="myIframe" src = '${url}' > </iframe>`
                navigator.clipboard.writeText(html)
                this.$root.$notification(this.$t('CopySucceeded'), 'success')
            },
            genrateQrCode(itemId, isShared, title) {
                this.selectedSurveyId = itemId
                // this.isShared = isShared
                this.surveyURL = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + `/form/${itemId}`
                this.qrCodeDialog = true
                this.isSharedQrForm = isShared
                this.selectedTitle = title
            },

            async removeSurvey(id) {
                if (await this.$root.$confirm(this.$t('Delete'), this.$t('ConfirmDelete'))) {
                    this.loading = true
                    SurveyService.deleteSurvey(id)
                        .then((res) => {
                            this.listSruveys()
                        })
                        .catch(() => {
                            this.$root.$notification(this.$t('SurveyInProcess'), 'error')
                        }).finally(() => this.loading = false)
                }
            },

            async makeCopy(surveyId) {

                if (await this.$root.$confirm(this.$t('MakeCopy'), this.$t('Are you sure you want to make a copy of this Survey ?'))) {
                    this.loading = true
                    SurveyService.loadSurveywithoutAuth(surveyId).then((res) => {
                        this.survey = res.data
                        this.survey.id = null
                        this.survey.isPublished = false
                        SurveyService.copySurvey(this.survey).then((res) => {
                            this.$router.push('/add-survey?id=' + res.data)
                        }).catch(() => {
                            this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                        }).finally(() => {
                            this.loading = false
                        })
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                    })

                }
            },
            RemoveHtmlTags(text) {
                return useStripHtml(text)
            },

            filterGrid(e) {

                if (e) {
                    this.mainSurveyList = this.surveys
                    switch (e.value) {
                        case 'isShared':
                            this.surveys = this.surveys.filter(x => x.isShared == true)
                            break
                        case 'showOnHomePage':
                            this.surveys = this.surveys.filter(x => x.showOnHomePage == true)
                            break
                        case 'isPublished':
                            this.surveys = this.surveys.filter(x => x.isPublished == true)
                            break
                        case 'active':
                            this.surveys = this.surveys.filter(x => x.expired == false)
                            break
                        default:
                    }
                }
                else {
                    this.surveys = this.mainSurveyList
                }
            }
        }
    }
</script>

<style scoped>
    .v-chip.draft {
        background: #dedede;
    }

    .v-chip.pending {
        background: #ffaa2c;
    }

    .v-chip.approved {
        background: var(--v-secondary-base);
        color: #fff
    }

    ::v-deep .v-data-table tbody tr {
        cursor: pointer;
    }
</style>